import $ from 'jquery';
import { scrollToGo } from '~loader/loader-utils';
import { getState } from '~src/state';

/**
 * Aggiunge i blocchi della navigazione utente in base alle sue scelte
 */
export const templateAddBreadcrumbs = () => {
  // Skip rendering breadcrumbs entirely when running inside the Home Create modal
  try {
    if (document?.body?.classList?.contains('home-create-modal-open')) {
      const $modalContainer = $('.container-navigation-breadcrumbs');
      if ($modalContainer && $modalContainer.length) {
        $modalContainer.hide();
      }
      return;
    }
  } catch (e) {
    // non-blocking safeguard
  }
  $('body').off('click', '.box-breadcrumbs-text', scrollToGo);
  $('body').on('click', '.box-breadcrumbs-text', scrollToGo);

  let breadcrumbsHtmlBlock = '';

  const projectType = getState('selected.tipo');
  const format = getState('selected.formato');
  const servizio = getState('selected.servizio');

  if (projectType && projectType.name) {
    breadcrumbsHtmlBlock += `
      <div
        class="box-container-breadcrumbs p-0">
        <div class="box-breadcrumbs-text box-breadcrumbs-1 bg-color-projects text-center" id="bread-crumb-projects" data-scroll-to="container-projects">${projectType.name}</div>
      </div>
    `;
  }

  if (servizio && servizio.cognome && servizio.nome) {
    breadcrumbsHtmlBlock += `
      <div
        class="box-container-breadcrumbs p-0">
        <div class="box-breadcrumbs-text box-breadcrumbs-2 bg-color-servizio text-center" data-scroll-to="container-servizio">${servizio.cognome} ${servizio.nome}</div>
      </div>
    `;
  }

  if (format && format.name) {
    breadcrumbsHtmlBlock += `
      <div
        class="box-container-breadcrumbs p-0">
        <div class="box-breadcrumbs-text box-breadcrumbs-3 text-center bg-color-formats" data-scroll-to="container-formats">${format.name}</div>
      </div>
    `;
  }

  const breadcrumbsHtmlBlockTitle = `
  
  <h4 class="bread-crumb-container-title color-default">
      Cosa stai creando
  </h4>`;

  const $title = $('#editor-navigation-breadcrumbs-title');
  const $crumbs = $('#editor-navigation-breadcrumbs');
  const $container = $('.container-navigation-breadcrumbs');

  // If the loader containers are not present (e.g., in Create modal), just no-op
  if (!$container.length || !$title.length || !$crumbs.length) {
    return;
  }

  if (breadcrumbsHtmlBlock) {
    $title.html(breadcrumbsHtmlBlockTitle);
    $crumbs.html(breadcrumbsHtmlBlock);
    $container.show();
    const element = document.querySelector('.container-navigation-breadcrumbs');
    if (element && element.classList) {
      element.classList.add('animate__animated', 'animate__bounceOutLeft');
    }
  } else {
    $container.hide();
  }
};
